(function () {
  // =========================
  // CONFIG
  // =========================
  var GIFT_PRODUCT_HANDLE = 'garrafa-termica-norm';
  var TIMEZONE = 'Europe/Lisbon';

  // Janela da promoção (Lisboa)
  // Ajusta se necessário:
  // Ex.: 2025-12-13 00:00 até 2025-12-14 23:59
  var PROMO_START = { y: 2025, m: 12, d: 13, hh: 0,  mm: 0  };
  var PROMO_END   = { y: 2025, m: 12, d: 14, hh: 23, mm: 59 };

  // Se quiseres ver logs:
  var DEBUG = false;

  function log() { if (DEBUG) console.log.apply(console, ['[NORM GWP]'].concat([].slice.call(arguments))); }
  function warn() { if (DEBUG) console.warn.apply(console, ['[NORM GWP]'].concat([].slice.call(arguments))); }

  // =========================
  // HELPERS
  // =========================
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function tzNowDate(timeZone) {
    var s = new Date().toLocaleString('en-US', { timeZone: timeZone });
    return new Date(s);
  }

  function toComparableNumber(o) {
    return (o.y * 100000000) + (o.m * 1000000) + (o.d * 10000) + (o.hh * 100) + o.mm;
  }

  function promoIsActive() {
    var now = tzNowDate(TIMEZONE);
    var nowN = toComparableNumber({
      y: now.getFullYear(),
      m: now.getMonth() + 1,
      d: now.getDate(),
      hh: now.getHours(),
      mm: now.getMinutes()
    });
    var active = nowN >= toComparableNumber(PROMO_START) && nowN <= toComparableNumber(PROMO_END);
    log('promoIsActive?', active, now.toString());
    return active;
  }

  async function fetchJSON(url) {
    var res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('HTTP ' + res.status + ' for ' + url);
    return await res.json();
  }

  async function getGiftVariantId() {
    var product = await fetchJSON('/products/' + GIFT_PRODUCT_HANDLE + '.js');
    var variants = product.variants || [];
    var v = null;

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { v = variants[i]; break; }
    }
    if (!v && variants.length) v = variants[0];
    if (!v) throw new Error('No variants found for gift product');

    return Number(v.id);
  }

  async function getCart() {
    return await fetchJSON('/cart.js');
  }

  async function cartAdd(variantId, qty) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    });
    if (!res.ok) {
      var t = await res.text();
      throw new Error('cartAdd failed: ' + res.status + ' ' + t);
    }
  }

  async function cartChange(lineKey, qty) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
    if (!res.ok) {
      var t = await res.text();
      throw new Error('cartChange failed: ' + res.status + ' ' + t);
    }
  }

  async function refreshCartSections() {
    // nomes comuns em temas OS2; Be Yours costuma suportar cart-drawer/cart-icon-bubble
    var sectionNames = ['cart-drawer', 'cart-icon-bubble', 'cart-notification', 'header', 'mini-cart'];

    try {
      var url = '/?sections=' + encodeURIComponent(sectionNames.join(','));
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return;

      var sections = await res.json();

      function replaceIfFound(selectors, html) {
        if (!html) return false;
        for (var i = 0; i < selectors.length; i++) {
          var el = document.querySelector(selectors[i]);
          if (el) { el.innerHTML = html; return true; }
        }
        return false;
      }

      var drawerHTML = sections['cart-drawer'] || sections['mini-cart'] || '';
      replaceIfFound(['#CartDrawer', '#cart-drawer', '[data-cart-drawer]', '.cart-drawer', '.mini-cart'], drawerHTML);

      var bubbleHTML = sections['cart-icon-bubble'] || '';
      replaceIfFound(['#cart-icon-bubble', '[data-cart-count]', '.cart-count-bubble', '.header__cart-count'], bubbleHTML);

      var notifHTML = sections['cart-notification'] || '';
      replaceIfFound(['#cart-notification', '[data-cart-notification]', '.cart-notification'], notifHTML);

      window.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
      warn('refreshCartSections failed', e);
    }
  }

  // =========================
  // MAIN
  // =========================
  var isRunning = false;

  async function enforceGift() {
    if (isRunning) return;
    isRunning = true;

    try {
      if (!promoIsActive()) return;

      var eligibleIds = (window.NORM_GWP_ELIGIBLE_PRODUCT_IDS || []).map(function (n) { return Number(n); });
      if (!eligibleIds.length) {
        warn('Eligible IDs empty. Check snippet inclusion or collection handles.');
        return;
      }
      var eligibleSet = {};
      for (var k = 0; k < eligibleIds.length; k++) eligibleSet[eligibleIds[k]] = true;

      var giftVariantId = await getGiftVariantId();
      var cart = await getCart();
      var items = cart.items || [];

      var giftLine = null;
      var hasEligibleItem = false;

      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (Number(it.variant_id) === Number(giftVariantId)) {
          giftLine = it;
        } else {
          if (eligibleSet[Number(it.product_id)]) hasEligibleItem = true;
        }
      }

      log('hasEligibleItem?', hasEligibleItem, 'giftLine?', !!giftLine);

      if (hasEligibleItem) {
        if (!giftLine) {
          await cartAdd(giftVariantId, 1);
          await refreshCartSections();
          await sleep(150);
        } else if (giftLine.quantity > 1) {
          await cartChange(giftLine.key, 1);
          await refreshCartSections();
          await sleep(150);
        }
      } else {
        if (giftLine) {
          await cartChange(giftLine.key, 0);
          await refreshCartSections();
          await sleep(150);
        }
      }
    } catch (e) {
      warn('enforceGift error', e);
    } finally {
      isRunning = false;
    }
  }

  function hookNetwork() {
    var origFetch = window.fetch;
    window.fetch = async function () {
      var res = await origFetch.apply(window, arguments);
      try {
        var url = String(arguments[0] || '');
        if (url.indexOf('/cart') !== -1) setTimeout(enforceGift, 50);
      } catch (_) {}
      return res;
    };

    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._gwp_url = url;
      return origOpen.apply(this, arguments);
    };

    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', function () {
        try {
          var url = String(this._gwp_url || '');
          if (url.indexOf('/cart') !== -1) setTimeout(enforceGift, 50);
        } catch (_) {}
      });
      return origSend.apply(this, arguments);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    hookNetwork();
    enforceGift();
    window.addEventListener('focus', enforceGift);
    setInterval(function () { if (promoIsActive()) enforceGift(); }, 20000);
  });
})();
